import { ChevronRight } from 'lucide-react';
import { Item, ItemActions, ItemContent, ItemDescription, ItemGroup, ItemTitle, cn } from '@design-system';

export interface LinkListEntry {
  id: string;
  title: string;
  description: string;
  onSelect: () => void;
}

export function LinkList({ entries, className }: { entries: LinkListEntry[]; className?: string }) {
  return (
    <ItemGroup className={cn('gap-3', className)}>
      {entries.map(entry => (
        <Item key={entry.id} variant="outline" className="hover:border-primary/30 items-start rounded-xl bg-white text-left" asChild>
          <button type="button" onClick={entry.onSelect}>
            <ItemContent>
              <ItemTitle>{entry.title}</ItemTitle>
              <ItemDescription className="text-pretty">{entry.description}</ItemDescription>
            </ItemContent>
            <ItemActions className="self-center">
              <ChevronRight className="size-4" />
            </ItemActions>
          </button>
        </Item>
      ))}
    </ItemGroup>
  );
}
